import {Brick, registerBrick, GlobalProperties, BrickContext} from 'olympe';
import {getLogger} from '@olympeio/core';

const Application = '0113030000000aca1100';
const MATOMO_SCRIPT_ID = 'matomo-tracking-code';
const MATOMO_ENABLED_FLAG = 'matomo-is-enabled';

/**
 * @return {Element}
 */
function isMatomoTrackingInserted() {
    return document.querySelector(`script#${MATOMO_SCRIPT_ID}`);
}

/**
 *
 * @param {BrickContext} $
 * @param {boolean} enabled
 */
function setMatomoTrackingEnabled($, enabled) {
    if (typeof enabled !== 'boolean') {
        throw new Error('Invalid enabled argument, must be a boolean');
    }
    const applicationContext = getApplicationContext($);
    applicationContext.set(MATOMO_ENABLED_FLAG, enabled);
}

/**
 * @param {BrickContext} $
 * @return {BrickContext}
 */
function getApplicationContext($) {
    return $.getClosest({modelTag: Application});
}


export default class MatomoInsertTrackingCode extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} domain
     * @param {string} siteId
     * @param {function()} forwardEvent
     */
    update($, [domain, siteId], [forwardEvent]) {
        const logger = getLogger('Matomo');

        if ($.get(GlobalProperties.EDITION, true)) {
            logger.debug('Ignoring tracking code in EDITION mode.');
            forwardEvent();
            return;
        }

        if (typeof domain !== 'string' || domain.length === 0) {
            logger.error('Invalid inputs, domain is required and must be string. Ignoring tracking code');
            forwardEvent();
            return;
        }

        if (isMatomoTrackingInserted()) {
            logger.error('Tracking code is already inserted, you probably use the `[Matomo] InsertTrackingCode` brick several times in your application');
            forwardEvent();
            return;
        }

        const enabled = typeof siteId === 'string' && siteId.length > 0;
        setMatomoTrackingEnabled($, enabled);

        if (!enabled) {
            forwardEvent();
            return;
        }

        const _paq = window._paq || [];
        window._paq = _paq;
        (function() {
            const u=`//${domain}/`;
            _paq.push(['setTrackerUrl', u+'matomo.php']);
            _paq.push(['setSiteId', siteId]);
            const g = document.createElement('script');
            const s = document.getElementsByTagName('script')[0];
            g.id = MATOMO_SCRIPT_ID;
            g.async=true;
            g.src=u+'matomo.js';
            s.parentNode.insertBefore(g, s);
        })();
        forwardEvent();
    }
}

registerBrick('018a6446d34894b659b3', MatomoInsertTrackingCode);
